import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";

import { LabourerContext } from "../contexts/LabourerContext";
import LabourerNavbar from "../components/Labourer/LabourerNavbar";
import FullPageLoader from "../components/FullPageLoader";
import MobileNavbar from "../components/MobileNavbar";
import LabourerMobileNavOverlay from "../components/LabourerMobileNavOverlay";

const LabourerLayout = () => {
  const { labourer } = useContext(LabourerContext);

  const location = useLocation();
  const navigate = useNavigate();

  const [isMobileNavOverlayOpen, setIsMobileNavOverlayOpen] = useState(false);

  useEffect(() => {
    setIsMobileNavOverlayOpen(false);
  }, [location.pathname]);

  if (!labourer) return <FullPageLoader />;

  if (labourer && !labourer.completedRegistration) {
    if (location.pathname !== '/l/onboarding') {
      navigate('/l/onboarding');
    }
  }

  if (labourer && labourer.completedRegistration) {
    if (location.pathname === '/l/onboarding') {
      navigate('/l');
    }
  }

  const pathsWithoutNavbar = ['/l/onboarding']

  return (
    <>
      <div className="flex flex-col min-h-screen">
        {location.pathname !== '/l/onboarding' && <LabourerNavbar />}
        {location.pathname !== '/l/onboarding' && <MobileNavbar onHamburgerClicked={e => setIsMobileNavOverlayOpen(true)} />}

        <LabourerMobileNavOverlay
          isOpen={isMobileNavOverlayOpen}
          onCloseClicked={e => setIsMobileNavOverlayOpen(false)}
        />

        <main className="flex justify-center flex-grow">
          <div className={`${pathsWithoutNavbar.includes(location.pathname) ? 'py-[20px]' : 'pt-[66px] pb-[20px]'} container px-2 md:py-[20px] md:px-0`}>
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
}

export default LabourerLayout;
